// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".j-list-items{position:relative;list-style:none;margin:0}", "",{"version":3,"sources":["webpack://./client/modules/common/dumb/list-items/list-items.css"],"names":[],"mappings":"AAAA,cACC,iBAAkB,CAClB,eAAgB,CAChB,QACD","sourcesContent":[".j-list-items {\n\tposition: relative;\n\tlist-style: none;\n\tmargin: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
